import React from 'react';
import moment from 'moment';
import { Form } from 'antd';
import AddAdministratorForm from '../formSections/AddAdministratorForm';

class AddAdministrator extends React.Component {
    render() {
        const {
            form,
            next,
            prev,
            name,
            handleMediumFormSubmit,
        } = this.props;

        return (
            <AddAdministratorForm
                name={name}
                form={form}
                next={next}
                prev={prev}
                handleMediumFormSubmit={handleMediumFormSubmit}
            />
        );
    }
}


class AddAdministratorData extends React.Component {
    getValueByFieldName(name, val) {
        if (name.includes('Date')) {
            return (val && moment(val)) || null;
        } else {
            return val;
        }
    }
    saveFormRef = formRef => {
        if (formRef && formRef.props && formRef.props.form) {
            this.formRef = formRef.props.form;
        } else {
            this.formRef = null;
        }
        this.props.setForm(this.props.name, this.formRef);
    };

    render() {
        const data = this.props.data
        return (
            <FormAddAdministrator
                {...this.props}
                data={data}
                wrappedComponentRef={this.saveFormRef}
                getValueByFieldName={this.getValueByFieldName}
                handleFieldsChange={this.props.handleFieldsChange}
            />
        );
    }
}

const FormAddAdministrator = Form.create({
    name: 'AddAdministrator',
    mapPropsToFields(props) {
        const { data } = props;
        let obj = {
            adminLastname: 
                        data && data.adminLastname || data.lastname || null,
            adminName: 
                        data && data.adminName || data.name || null, 
            adminPatronymic: 
                        data && data.adminPatronymic || data.patronymic || null, 
            adminBirthDate: 
                        data && data.adminBirthDate ? moment(data.adminBirthDate) :
                        data.birthDate ? moment(data.birthDate) :
                        null,
            adminEmail: 
                        data && data.adminEmail || data.email || null,
            adminPhoto: data && data.adminPhoto || data.photo || null,
        };
        
        Object.keys(obj).forEach(key => {
            obj[key] = Form.createFormField({
            value: props.getValueByFieldName(
                key,
                obj[key]
            ),
            });
        })
        
        return obj;
    },
})(AddAdministrator);

export default AddAdministratorData;
